"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.overrides = exports.typography = exports.Weight = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
// eslint-disable-next-line no-shadow
var Weight;
(function (Weight) {
    Weight[Weight["Medium"] = 400] = "Medium";
    Weight[Weight["Roman"] = 500] = "Roman";
    Weight[Weight["Heavy"] = 600] = "Heavy";
    Weight[Weight["Black"] = 700] = "Black";
    Weight[Weight["Bold"] = 900] = "Bold";
})(Weight = exports.Weight || (exports.Weight = {}));
const typography = () => ({
    fontFamily: 'Gilroy',
    display1: {},
    display2: {},
    display3: {},
    display4: {},
    headline: {},
    title: {},
    subheading: {},
    body1: {
        fontSize: 14,
        fontWeight: Weight.Medium,
        lineHeight: '17px',
    },
    body2: {
        fontSize: 14,
        fontWeight: Weight.Medium,
        lineHeight: '16px',
    },
    caption: {
        fontSize: 14,
        fontWeight: Weight.Medium,
        lineHeight: '16px',
        color: lib_palette_1.default.LavendarGrey.main,
    },
    button: {
        textTransform: 'inherit',
        fontSize: 14,
        fontWeight: Weight.Heavy,
        lineHeight: '19px',
    },
    h1: {
        // Tab / Dialog headings
        fontSize: 18,
        fontWeight: Weight.Heavy,
        lineHeight: '22px',
    },
    h2: {
        // Modal headings
        fontSize: 16,
        fontWeight: Weight.Heavy,
        lineHeight: '22px',
    },
    h3: {
        // Labelling default
        fontSize: 14,
        fontWeight: Weight.Black,
        lineHeight: '19px',
    },
    subtitle1: {
        fontSize: 16,
        fontWeight: Weight.Roman,
        lineHeight: '19px',
    },
    h4: {
        // Timeline heading
        fontSize: 14,
        fontWeight: Weight.Black,
        lineHeight: '16px',
    },
    h5: {
        // Timeline heading
        fontSize: 14,
        fontWeight: Weight.Heavy,
        lineHeight: '16px',
    },
    h6: {
        fontSize: 14,
        fontWeight: Weight.Heavy,
        lineHeight: '16px',
    },
    body1Next: {},
    body2Next: {},
    buttonNext: {},
    captionNext: {},
    subtitle2: {},
    overline: {},
});
exports.typography = typography;
const overrides = (themePalette) => {
    const typo = (0, exports.typography)();
    return {
        MuiPaper: {
            root: {
                '&:not(.newStyle)': {
                    '& em': {
                        fontFamily: 'Gilroy',
                        color: lib_palette_1.default.Black.dark,
                        fontStyle: 'normal',
                        fontWeight: 'bold',
                    },
                },
            },
        },
        MuiButton: {
            contained: {
                '&:not(.newStyle)': {
                    backgroundColor: lib_palette_1.default.LavendarGrey.main,
                    boxShadow: 'none',
                    '&.Mui-disabled': {
                        backgroundColor: lib_palette_1.default.LavendarGrey.light,
                    },
                    '&:hover': {
                        backgroundColor: lib_palette_1.default.LavendarGrey.dark,
                    },
                },
            },
            containedPrimary: {
                '&:not(.newStyle)': {
                    backgroundColor: themePalette.positive.main,
                    '&:hover': {
                        backgroundColor: themePalette.positive.dark,
                    },
                },
            },
            outlined: {
                '&:not(.newStyle)': {
                    borderColor: lib_palette_1.default.BorderGrey.main,
                    '&:hover': {
                        borderColor: lib_palette_1.default.BorderGrey.dark,
                        backgroundColor: lib_palette_1.default.LavendarGrey.background,
                    },
                },
            },
            text: {
                '&:not(.newStyle)': {
                    '&.MuiButton-sizeSmall': typo.body1,
                },
            },
            root: {
                '&:not(.newStyle)': {
                    '&:hover': {
                        backgroundColor: `${lib_palette_1.default.BackgroundGrey.main}`,
                    },
                },
            },
            sizeSmall: {
                '&:not(.newStyle)': typo.h5,
            },
            sizeLarge: {
                '&:not(.newStyle)': {
                    padding: 10,
                },
            },
            //the following has to be done for this bug - https://github.com/mui-org/material-ui-pickers/issues/1376
            textPrimary: {
                color: lib_palette_1.default.Black.main,
            },
        },
        MuiAvatar: {
            root: {
                '&.MuiAvatar-colorDefault': {
                    color: lib_palette_1.default.White.main,
                    backgroundColor: lib_palette_1.default.LavendarGrey.main,
                },
            },
        },
        MuiIconButton: {
            root: {
                '&:not(.newStyle)': {
                    padding: 6,
                    '&:hover': {
                        backgroundColor: `${lib_palette_1.default.BackgroundGrey.main}`,
                    },
                },
            },
        },
        MuiFormHelperText: {
            root: {
                color: lib_palette_1.default.GreyBlue.main,
            },
        },
        MuiCheckbox: {
            colorPrimary: {
                '&:not(.newStyle)': {
                    color: lib_palette_1.default.BorderGrey.main,
                    '& input': {
                        backgroundColor: `white`,
                    },
                    '&.Mui-checked': {
                        color: themePalette.positive.main,
                    },
                    '&:hover': {
                        color: lib_palette_1.default.PastelBlue.main,
                        backgroundColor: `${themePalette.BackgroundGrey.main} !important`,
                    },
                    '&.Mui-checked:hover': {
                        color: themePalette.positive.main,
                        backgroundColor: `${themePalette.positive.background} !important`,
                    },
                },
            },
            colorSecondary: {
                '&:not(.newStyle)': {
                    color: lib_palette_1.default.BorderGrey.main,
                    '& input': {
                        backgroundColor: `white`,
                    },
                    '&:hover': {
                        color: lib_palette_1.default.PastelBlue.main,
                        backgroundColor: `${lib_palette_1.default.BackgroundGrey.main} !important`,
                    },
                },
            },
        },
        MuiInput: {
            input: typo.body1,
            underline: {
                '&:not(.newStyle)': {
                    '&:after': {
                        borderBottomColor: themePalette.secondary.main,
                    },
                    '&:before': {
                        borderBottomColor: lib_palette_1.default.BorderGrey.main,
                    },
                    '&:hover:not(.Mui-disabled):before': {
                        borderBottom: `1px solid ${lib_palette_1.default.LavendarGrey.main}`,
                    },
                },
            },
            root: {
                '&:not(.newStyle)': {
                    '&:hover.OBHideLine.MuiInput-underline:before': {
                        borderBottomColor: lib_palette_1.default.BackgroundGrey.main,
                    },
                    '&.OBHideLine.MuiInput-underline:before': {
                        borderBottomColor: 'transparent',
                    },
                },
            },
        },
        MuiStepper: {
            root: {
                '&:not(.newStyle)': {
                    padding: 0,
                },
            },
        },
        MuiOutlinedInput: {
            root: {
                '&:not(.newStyle)': {
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: lib_palette_1.default.InputBorderGrey.main,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: lib_palette_1.default.InputBorderGrey.main,
                    },
                    '&:hover.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: themePalette.secondary.light,
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: themePalette.secondary.light,
                    },
                },
            },
            input: {
                '&:not(.newStyle)': Object.assign({
                    paddingTop: 8,
                    paddingBottom: 8,
                    '&::placeholder': {
                        color: lib_palette_1.default.Liquorice.main,
                    },
                }, typo.body1),
            },
            multiline: {
                '&:not(.newStyle)': {
                    padding: '2px 8px',
                },
            },
            inputMarginDense: {
                '&:not(.newStyle)': {
                    paddingTop: 14,
                    paddingBottom: 14,
                },
            },
            adornedStart: {
                '&:not(.newStyle)': {
                    paddingLeft: 10,
                },
            },
            // adornedEnd: {
            // 	'&:not(.newStyle)': {
            // 		paddingRight: 6,
            // 	},
            // },
        },
        MuiInputLabel: {
            outlined: {
                '&:not(.newStyle)': {
                    color: themePalette.secondary.main,
                    transform: 'translate(14px, 10px) scale(1)',
                    '&.MuiInputLabel-marginDense': {
                        transform: 'translate(14px, 16px) scale(1)',
                    },
                    '&.MuiInputLabel-shrink': {
                        color: lib_palette_1.default.GreyBlue.main,
                        transform: 'translate(14px, -6px) scale(0.75)',
                    },
                    '&.Mui-focused': {
                        color: themePalette.secondary.main,
                    },
                },
            },
        },
        MuiTab: {
            root: {
                '&:not(.newStyle)': {
                    minWidth: 48,
                    fontSize: 14,
                    marginRight: 24,
                    padding: '6px 0',
                },
            },
        },
        MuiTabs: {
            root: {
                '&:not(.newStyle)': {
                    minHeight: 44,
                },
            },
            indicator: {
                '&:not(.newStyle)': {
                    height: 3,
                    borderRadius: '3px 3px 0 0',
                },
            },
        },
        MuiChip: {
            root: {
                '&:not(.newStyle)': Object.assign(Object.assign({ height: 24 }, typo.body2), { color: '#ffffff' }),
            },
        },
        MuiRadio: {
            root: {
                '&:not(.newStyle)': {
                    padding: 4,
                },
            },
        },
        MuiExpansionPanel: {
            root: {
                '&:not(.newStyle)': {
                    border: 0,
                    margin: 0,
                    marginTop: 16,
                    borderRadius: 16,
                    '&:before': {
                        backgroundColor: 'transparent !important',
                    },
                    '&.Mui-expanded': {
                        margin: 0,
                        // marginTop: '16px !important',
                        '&:first-child': {
                            marginTop: '0 !important',
                        },
                    },
                    '&.subgroup': {
                        border: `1px solid ${lib_palette_1.default.BackgroundGrey.main} !important`,
                        margin: `8px !important`,
                    },
                    '&.parentgroup': {
                        backgroundColor: `${lib_palette_1.default.WhiteSmoke.main} !important`,
                    },
                },
            },
        },
        MuiExpansionPanelSummary: {
            root: {
                '&:not(.newStyle)': {
                    overflow: 'hidden',
                    minHeight: 48,
                    '&.Mui-expanded': {
                        minHeight: 48,
                    },
                },
            },
            content: {
                '&:not(.newStyle)': {
                    margin: 0,
                    '&.Mui-expanded': {
                        margin: 0,
                    },
                },
            },
        },
        MuiExpansionPanelDetails: {
            root: {
                '&:not(.newStyle)': {
                    padding: '8px 18px 18px 18px',
                },
            },
        },
        MuiFormControlLabel: {
            root: {
                '&:not(.newStyle)': {
                    marginLeft: 0,
                },
            },
            label: {
                '&:not(.newStyle)': {
                    fontSize: 14,
                    fontWeight: Weight.Roman,
                    lineHeight: '19px',
                },
            },
        },
        MuiDialogTitle: {
            root: {
                padding: '16px 24px 0',
            },
        },
        MuiDialogActions: {
            root: {
                padding: '8px 24px 16px 24px',
                justifyContent: 'space-between',
            },
        },
        MuiDialogContent: {
            root: {
                overflowY: 'visible',
                display: 'flex',
                flexDirection: 'column',
                padding: 0,
                '& .MuiDialogActions-root': {
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                },
                '&:first-child': {
                    paddingTop: '4px !important',
                },
            },
        },
        MuiDialog: {
            paper: {
                overflowY: 'visible', // for react-select
            },
        },
        MuiStepConnector: {
            line: {
                '&:not(.newStyle)': {
                    borderColor: lib_palette_1.default.BlackCoral.main,
                },
            },
        },
        MuiPickersBasePicker: {
            pickerView: {
                minHeight: 340,
            },
        },
        MuiPickersToolbar: {
            toolbar: {
                backgroundColor: lib_palette_1.default.secondary.main,
            },
        },
        MuiPickersClock: {
            pin: {
                backgroundColor: lib_palette_1.default.secondary.main,
            },
            meridiemButtonSelected: {
                backgroundColor: lib_palette_1.default.BackgroundGrey.main,
                '&:hover': {
                    backgroundColor: lib_palette_1.default.primary.background,
                },
            },
        },
        MuiPickersClockNumber: {
            clockNumberSelected: {
                backgroundColor: lib_palette_1.default.secondary.main,
            },
        },
        MuiPickersClockPointer: {
            pointer: {
                backgroundColor: lib_palette_1.default.secondary.main,
            },
            thumb: {
                color: lib_palette_1.default.secondary.main,
                borderColor: lib_palette_1.default.secondary.main,
            },
            animateTransform: {
                color: lib_palette_1.default.secondary.main,
            },
            noPoint: {
                backgroundColor: lib_palette_1.default.secondary.main,
            },
        },
    };
};
exports.overrides = overrides;
